/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListsWithMembership.defs'
export { main as default } from './getListsWithMembership.defs'
